import React from 'react';
import { useTranslation } from 'react-i18next';

type MessageProps = {
    code: string;
    interpolationValues?: Record<string, string>;
    className?: string;
};

const Message = ({ code, interpolationValues = {}, className }: MessageProps) => {
    const { t } = useTranslation();

    return <span className={className}>{t(code, interpolationValues)}</span>;
};

export default Message;
